import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const BotStripWrapper = styled(Flex)`
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background-color: ${colorsPalettes.sky[100]};
    border-top: 1px solid ${colorsPalettes.sky[200]};
    border-radius: 0 0 6px 6px;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
        background-color: ${colorsPalettes.sky[200]};
    }
`;

export const BotStripLeading = styled(Flex)`
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
`;

export const BotStripText = styled.span`
    ${setFontVariant("chip1", colorsPalettes.carbon[500])};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
